import { getErrorMessage, getFieldErrors } from '@/core/api/response-handler';

/**
 * Erorile serverului la «Corectare Formular de Înscriere» (Raport Înscrieri), impartite dupa
 * ce se poate arata SUB un camp al dialogului si ce nu.
 *
 * De ce exista: pe 07.10 adminul a primit «Eroare la validarea datelor. Verifică datele trimise.»
 * la salvarea unui nume de scoala, fara sa afle ce camp e respins — iar campul respins nici nu era
 * unul din dialog. Backendul trimite harta `errors`; aici ajunge la om.
 *
 * Cheile sunt cele din `SchoolRequestDTO` (`adresa.judet` pentru campurile imbricate) si sunt
 * aceleasi pe care `EditableFormDialog` le foloseste in `handleFieldChange`.
 */
export const CAMPURI_DIALOG_CORECTARE: readonly string[] = [
    'codSiiirUnitate',
    'numeInstitutieInvatamant',
    'cui',
    'telefon',
    'numarElevi',
    'numeReprezentatLegal',
    'adresa.judet',
    'adresa.oras',
    'adresa.comuna',
    'adresa.sat',
    'adresa.strada',
    'adresa.numar',
    'adresa.codPostal',
];

export interface EroriCorectareFormular {
    /** Erori pe campuri pe care dialogul le randeaza: se afiseaza sub camp. */
    vizibile: Record<string, string>;
    /** Erori pe campuri fara input in dialog: se pot arata doar in toast, cu numele campului. */
    invizibile: Record<string, string>;
}

export function eroriCorectareFormular(error: unknown): EroriCorectareFormular {
    const rezultat: EroriCorectareFormular = { vizibile: {}, invizibile: {} };
    const erori = getFieldErrors(error);
    if (!erori) return rezultat;

    for (const [camp, mesaj] of Object.entries(erori)) {
        if (typeof mesaj !== 'string' || !mesaj.trim()) continue;
        if (CAMPURI_DIALOG_CORECTARE.includes(camp)) rezultat.vizibile[camp] = mesaj;
        else rezultat.invizibile[camp] = mesaj;
    }
    return rezultat;
}

/**
 * Textul toastului. Fara detalii pe campuri ramane mesajul serverului (comportamentul de pana acum).
 *
 * Campurile fara input apar cu NUMELE lor tehnic si cu mesajul serverului, verbatim: adminul nu le
 * poate corecta din dialog, deci textul e de trimis mai departe, nu de urmat.
 */
export function mesajEroareCorectare(error: unknown): string {
    const { vizibile, invizibile } = eroriCorectareFormular(error);
    const nVizibile = Object.keys(vizibile).length;
    const lista = Object.entries(invizibile).map(([camp, mesaj]) => `${camp} (${mesaj})`);

    if (nVizibile === 0 && lista.length === 0) {
        return getErrorMessage(error, 'Eroare la actualizarea formularului');
    }

    const parti = ['Formularul nu a fost salvat.'];
    if (nVizibile === 1) parti.push('Verifică câmpul marcat.');
    if (nVizibile > 1) parti.push('Verifică câmpurile marcate.');
    if (lista.length > 0) {
        parti.push(`Date respinse care nu apar în acest formular: ${lista.join(', ')}.`);
    }
    return parti.join(' ');
}
